import { render } from "./TextStructureWidget.vue?vue&type=template&id=fbb06ef2&scoped=true"
import script from "./TextStructureWidget.vue?vue&type=script&lang=js"
export * from "./TextStructureWidget.vue?vue&type=script&lang=js"

import "./TextStructureWidget.vue?vue&type=style&index=0&id=fbb06ef2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbb06ef2"]])

export default __exports__